(() => {
  const header = document.querySelector('[data-gn-header]');
  if (!header) return;
  const menu = header.querySelector('[data-gn-mobile-menu]');
  const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 24);
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
  if (!menu) return;
  menu.querySelectorAll('nav a').forEach((link) => link.addEventListener('click', () => {
    menu.open = false;
  }));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu.open) {
      menu.open = false;
      menu.querySelector('summary')?.focus();
    }
  });
  document.addEventListener('click', (event) => {
    if (menu.open && !menu.contains(event.target)) menu.open = false;
  });
})();
